import React from 'react';
import { cn } from '../../lib/cn';

const SIDES = {
  top:    'bottom-[calc(100%+6px)] left-1/2 -translate-x-1/2',
  bottom: 'top-[calc(100%+6px)] left-1/2 -translate-x-1/2',
  left:   'right-[calc(100%+6px)] top-1/2 -translate-y-1/2',
  right:  'left-[calc(100%+6px)] top-1/2 -translate-y-1/2'
};

export default function Tooltip({ label, side = 'top', className, children }) {
  if (!label) return children;
  return (
    <span className={cn('relative inline-flex group', className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-50 whitespace-nowrap',
          'bg-slate-900 text-white text-[11px] font-medium rounded-md px-2 py-1 shadow-pop',
          'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100',
          'transition-opacity duration-150',
          SIDES[side]
        )}
      >
        {label}
      </span>
    </span>
  );
}
